<script>
import layout from '@src/mixins/layout.vue'
export default {
  mixins: [layout],
  data() {
    return {
      displayFilter: false,
      filterOptions: {
        gender: [
          {
            key: 'M',
            value: 'Male',
            total: 300,
          },
          {
            key: 'F',
            value: 'Female',
            total: 542,
          },
        ],
      },
      selectedGender: [],
      selectedLanguage: [],
    }
  },
  methods: {
    clear() {
      this.selectedGender = []
      this.selectedLanguage = []
    },
    applyFilter() {
      const filterData = {
        gender: this.selectedGender,
        language: this.selectedLanguage,
      }
      this.$emit('filter-applied', filterData)
      this.displayFilter = false
    },
  },
}
</script>

<template>
  <v-menu
    v-model="displayFilter"
    :close-on-content-click="false"
    :nudge-width="200"
    :max-width="mobile ? '94%' : 400"
    class="ma-auto"
    :offset-y="notDesktop ? notDesktop : !notDesktop"
    :offset-x="notDesktop ? !notDesktop : notDesktop"
    align="center"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="telehealthBtn"
        text
        class="text-decoration-none"
        :class="$style.textTransform"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        Filter
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="px-2" :class="$style.boldTitle"
              >Gender</v-list-item-title
            >
            <v-row no-gutters class="px-2">
              <v-col
                v-for="(sex, index) in filterOptions.gender"
                :key="sex.key"
                cols="6"
              >
                <v-checkbox
                  v-model="selectedGender"
                  multiple
                  :value="sex.key"
                  :hide-details="index !== sex.length - 1"
                  class="mx-auto"
                >
                  <template v-slot:label>
                    {{ sex.value }}
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          text
          color="primary"
          :class="[$style.textTransform, $style.actionBtn]"
          @click="clear"
        >
          Clear
        </v-btn>
        <v-btn
          color="primary"
          rounded
          class="px-8"
          :class="[$style.textTransform, $style.actionBtn]"
          @click="applyFilter"
        >
          Apply Filters
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style lang="scss" module>
@import '@design';

.textTransform {
  text-transform: none !important;
}
.lightText {
  font-size: 15px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.55) !important;
}
.boldTitle {
  font-size: 15px;
  font-weight: 600 !important;
}
.actionBtn {
  font-size: 16px;
  font-weight: 600;
}
</style>

<style scoped>
/deep/ .v-list-item .v-list-item__title {
  line-height: 1.3 !important;
}

/deep/ .v-input .v-label {
  font-weight: 500;
  color: #000 !important;
}
</style>
